module.exports = __webpack_public_path__ + "static/media/saved-off.b3a1afbe.svg";